export const boardFinancialTour = {
  key: "boardFinancial",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-financial-chart"]',
      content: t("Tour_BoardFinancial_Chart"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-financial-addtransaction"]',
      content: t("Tour_BoardFinancial_AddTransaction"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-financial-report"]',
      content: t("Tour_BoardFinancial_Report"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-financial-settings"]',
      content: t("Tour_BoardFinancial_Settings"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-finpay-income"]',
      content: t("Tour_FinPay_Income"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-finpay-expense"]',
      content: t("Tour_FinPay_Expense"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-finpay-balance"]',
      content: t("Tour_FinPay_Balance"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-finpay-add"]',
      content: t("Tour_FinPay_Add"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-finpay-card"]',
      content: t("Tour_FinPay_Card"),
      placement: "top",
    },
  ],
};
